export const GET_GROUPS = 'GET_GROUPS'
export const GET_MEMBERS = 'GET_MEMBERS'
export const SET_GROUPS = 'SET_GROUPS'
export const SET_MEMBERS = 'SET_MEMBERS'
export const GET_GROUPS_ERROR = 'GET_GROUPS_ERROR'
export const GET_MEMBERS_ERROR = 'GET_MEMBERS_ERROR'
export const RESET_GROUPS = 'RESET_GROUPS'
export const RESET_MEMBERS = 'RESET_MEMBERS'
